import React, { ReactNode } from 'react';
import { styled } from '@mui/material/styles';
import { Box, Button, ButtonProps, Portal } from '@mui/material';
import { LoadingOverlay } from '@/components/patcher';
import { useAppDispatch } from '@/hooks';
import { openNewPatientDrawer } from '@/modules/appContext';
import { ImportUserIcon } from '@/components/icon';
import { useCurrentUser } from '@ianesthesie-kit/redux';
import { PhoneArrowIcon } from './icons';
import { PatientCreatedSnackbar } from '@/components/drawer/newPatientDrawer';

const StyledHeaderIconButton = styled(Button)`
  width: 36px;
  height: 36px;
  aspect-ratio: 1 / 1;
  padding: 0;
  min-width: unset;
  position: relative;

  svg {
    width: 20px;
    height: 20px;
  }

  path {
    stroke: white;
  }
`;

export const HeaderIconButton = ({
  icon,
  loading,
  ...props
}: { icon: ReactNode; loading?: boolean } & ButtonProps) => (
  <Box position="relative">
    <StyledHeaderIconButton
      onClick={() => alert('Available soon')}
      disabled={loading}
      {...props}
    >
      {icon}
      {loading && <LoadingOverlay size={20} />}
    </StyledHeaderIconButton>
  </Box>
);

export const DashedDivider = styled('div')`
  align-self: stretch;
  border-left: ${(p) => `1px dashed ${p.theme.palette.themeColors.slate[300]}`};
  width: 1px;
  margin: 4px 2px;

  @media (max-width: 900px) {
    display: none;
  }
`;

export const ActionButtonContainer = styled('div')`
  display: flex;
  gap: 6px;
  overflow: auto;
`;

export const CreatePendingPatientContextButton = () => {
  const dispatch = useAppDispatch();

  return (
    <>
      <HeaderIconButton
        icon={<ImportUserIcon />}
        onClick={() => dispatch(openNewPatientDrawer())}
      />
      <Portal>
        <PatientCreatedSnackbar />
      </Portal>
    </>
  );
};

export const OpenZoomButton = () => {
  const user = useCurrentUser();
  return (
    <HeaderIconButton
      disabled={!user?.zoomUrl}
      icon={<PhoneArrowIcon />}
      onClick={() => window.open(user?.zoomUrl, '_blank')}
    />
  );
};

export const FlexEndWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  overflow: hidden;

  ${(p) => p.theme.breakpoints.down('md')} {
    flex-direction: column;
    align-items: flex-end;
    padding-top: 4px;
  }
`;

export const SpaceBetweenWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  overflow: hidden;

  ${(p) => p.theme.breakpoints.down('md')} {
    flex-direction: column-reverse;
    align-items: flex-start;
    padding-top: 4px;
  }
`;
